import {useState} from 'react';
import {Gamepad2} from 'lucide-react';
import {useLocation} from 'react-router-dom';
import {useCurrentWorkspaceUrlPrefix} from '@tinct/core-workspace';
import {GameModal, useJobAlert} from '@tinct/web-layout';

export function useBrandExtractionJobAlert() {
  const workspaceUrl = useCurrentWorkspaceUrlPrefix();
  const {pathname} = useLocation();
  const [gameOpen, setGameOpen] = useState(false);

  const {start} = useJobAlert({
    name: 'Brand Extraction',
    pendingUrl: `${pathname}`,
    completedUrl: `${workspaceUrl}/brand/company-profile`,
    alert: {
      message: 'You can stay (and play?)',
      variant: 'info',
      actions: [
        {
          label: <Gamepad2 className="size-4" />,
          onClick: () => setGameOpen(true),
          variant: 'outline',
          size: 'icon',
          dismissOnClick: false,
        }
      ],
    },
  });

  const gameModal = <GameModal open={gameOpen} onOpenChange={setGameOpen} />;

  return {start, gameModal};
}
